export const lavisPastrySquares = {
  id: "lavisPastrySquares",
  link: "/#/recipes/recipes/lavisPastrySquares",
  name: "Lavis Pastry Squares",
  cuisine: "Alethi",
  summary: "Crispy pastry squares for use with other recipes",
  inspiration: "American Piecrust",
  quantity: "About 32 squares",
  time: "30 minutes",
  notes:
    "We know that the Alethi eat pastries (Oathbringer ch 69). Unfortunately we don't get any more detail than that. So I experimented a bit with Mexican-style cornflour to see what kinds of pastry dough I could make without gluten. This one turned out basically the same as the full puff-pastry method I tried, but this is much easier and faster.",
  quotes:
    "I hear they've got storming good pastries at those fancy lighteyes parties. (Oathbringer ch 69)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/lavis-pastry-squares-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "maseca",
          display: "2 cups Mexican-style corn flour (Maseca)"
        },
        {
          item: "salt",
          display: "1/4 tsp salt"
        },
        {
          item: "dairy",
          display: "1/2 cup butter"
        },
        {
          item: "honey",
          display: "1 tbsp honey"
        },
        {
          item: "water",
          display: "1/2 to 2/3 cup very cold water"
        }
      ]
    }
  ],
  steps: [
    "Preheat oven to 425 degrees Fahrenheit. Combine Maseca and salt. Cut or crumble in the butter until it resembles small crumbs.",
    "Add the honey, then add the cold water a bit at a time. You want to just moisten all the dough - use a fork to stir as you pour the water, and toss and fluff the mixture to get everything moistened. Once everything almost starts holding together, stop adding water. Add this point you should be able to press it all into a ball.",
    "Generously sprinkle Maseca over your work surface. Roll out the dough to a rectangle 1/8 inch thick, sprinkling additional Maseca on top of the dough if needed to stop it from sticking to the rolling pin.",
    "Slice the crumbly broken edges off the rectangle and discard them. Slice into 2 inch squares.",
    "Place the squares on a baking sheet. Sliding a knife or thin metal spatula under them may help remove them from your work surface without breaking. Bake at 425 degrees Fahrenheit for about 12 minutes, until edges are browned and tops start to brown. Remove from oven and let cool.",
    "Use the pastry squares in the Simberries and Cream Pastry recipe or the Nuts and Honey Pastry recipe."
  ]
}
